import {AdobeExperiencePlatformService} from "@app/core/tracking/infrastructure/adobe-experience-platform-service";
import {Injectable} from "@angular/core";

/**
 * Dummy implementation of the AdobeExperiencePlatformService for platforms that do not support Adobe Experience Platform (Campaign) native SDK.
 */
@Injectable()
export class DummyAdobeExperiencePlatformService implements AdobeExperiencePlatformService {
    trackAction(action: string): void {
        //It does nothing
    }
}